import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";

const addOwnerSaga = undefined;
const actions = prepActions(service);
const ownerSagas = createController(service, actions);

export { actions, addOwnerSaga, ownerSagas };
